import { defineComponent as _defineComponent } from 'vue';
import InputText from 'primevue/inputtext';
import { computed, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'InputText',
    props: {
        id: { type: String, required: false },
        type: { type: String, required: false, default: 'text' },
        modelValue: { type: null, required: true, default: undefined },
        label: { type: String, required: false, default: '' },
        placeholder: { type: String, required: false, default: '' },
        vuelidateRuleResult: { type: null, required: false, default: undefined },
        submitted: { type: Boolean, required: false, default: false },
        disabled: { type: Boolean, required: false, default: false }
    },
    emits: ['update:modelValue'],
    setup(__props, { expose, emit: emits }) {
        expose();
        const props = __props;
        const invalid = computed(() => props.vuelidateRuleResult ? props.vuelidateRuleResult.$invalid : false);
        const errors = computed(() => props.vuelidateRuleResult ? props.vuelidateRuleResult.$errors : null);
        const __returned__ = { props, emits, invalid, errors, get InputText() { return InputText; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
